import * as ActionTypes from './region.actionTypes';
import * as AuthActionTypes from '../auth/auth.actionTypes';
import { combineReducers } from 'redux';
import keys from 'lodash/keys';
import merge from 'lodash/merge';
import omit from 'lodash/omit';

const allIds = (state = [], action) => {
  // Clear state when admin logins as another user
  if(action.type === AuthActionTypes.ADMIN_LOGIN_REQUEST){
    return [];
  }

  switch (action.type) {
    case ActionTypes.CREATE_REGION_SUCCESS:
      return [
        ...state,
        action.response.result
      ];
    case ActionTypes.DELETE_REGION_SUCCESS:
    case ActionTypes.DELETE_REGION_FAILURE:
      //TODO remove entry
      const deletedIndex = state.indexOf(action.payload.id);
      if(deletedIndex === -1) {
        return state;
      }
      return [
        ...state.slice(0, deletedIndex),
        ...state.slice(deletedIndex+1),
      ];
    case ActionTypes.READ_REGION_SUCCESS:
      const newEntryIndex = state.indexOf(action.response.result);
      if(newEntryIndex > -1) {
        return state;
      }
      return [
        ...state,
        action.response.result
      ];
    case ActionTypes.READ_REGIONS_SUCCESS:
      return action.response.result;
    default:
      return state;
  }
};

const byId = (state = {}, action) => {
  // Clear state when admin logins as another user
  if(action.type === AuthActionTypes.ADMIN_LOGIN_REQUEST){
    return {};
  }

  if(action.response && action.response.entities && action.response.entities.region) {
    if(action.response.method && action.response.method === 'DELETE') {
      console.log("//DELETE ENTITIES FROM STATE", state, action.response.entities);
      return omit(state, keys(action.response.entities.region));
    }
    return merge({}, state, action.response.entities.region);
  }
  return state;
};

const isFetching = (state = false, action) => {
  switch(action.type) {
    case ActionTypes.READ_REGIONS_REQUEST:
      return true;
    case ActionTypes.READ_REGIONS_SUCCESS:
    case ActionTypes.READ_REGIONS_FAILURE:
      return false;
    default:
      return state;
  }
};


const reducer = combineReducers({
  allIds,
  byId,
  isFetching,
  //errorMessage,
});

export default reducer;


// WEBPACK FOOTER //
// ./src/modules/region/region.reducer.js